<script lang="ts" setup>
import OmniTooltip from "@/components/omni/OmniTooltip.vue";
import { useI18n } from "vue-i18n";

withDefaults(
  defineProps<{
    size?: string | number;
    color?: string;
    hideTooltip?: boolean;
  }>(),
  {
    size: 16,
    color: "amber",
    hideTooltip: true,
  },
);

const { t } = useI18n();
</script>

<template>
  <omni-tooltip :disabled="!hideTooltip" container-class="d-flex align-center mr-1">
    <template #activator>
      <v-icon :color="color" :size="size">mdi-star</v-icon>
    </template>

    {{ t("trucks.exclusives-truck") }}
  </omni-tooltip>
</template>

<style lang="scss" scoped></style>
